import { useBrandConfiguration } from '@search/core/brands/context';
export const useMapListButton = () => {
    const { displayMapToggle } = useBrandConfiguration();
    return displayMapToggle === true;
};
